import { Tabs } from "../../shared";
import ViewAdminUser from "./ViewAdminUser";
import UpdateAdminUser from "./UpdateAdminUser";
import UpdateAdminType from "./UpdateAdminType";
import ProfileActivation from "./ProfileActivation";
import ResetPassword from "./ResetPassword";
import PermissionManager from "./PermissionManager";

const SubComponent = ({ data, adminType, currentUserType }) => {
    const { id, userType, status, adminPermissions, country } = data;

    const getAuthorizedTabs = (currentUserType, adminType) => {
        if (currentUserType === 99 && adminType === "system-admin") {
            return true;
        }
        if (currentUserType === 3 && adminType === "site-admin") {
            return true;
        }
        return false;
    };

    const basicTabItems = [
        {
            id: `view-${id}`,
            name: "View Admin",
            content: <ViewAdminUser data={data} />,
        },
    ];

    const tabItems = [
        ...basicTabItems,
        {
            id: `update-${id}`,
            name: "Update Admin",
            content: <UpdateAdminUser data={data} />,
        },
        {
            id: `type-${id}`,
            name: "Update Admin Type",
            content: <UpdateAdminType id={id} userType={userType} />,
        },
        {
            id: `profile-activation-${id}`,
            name: "Profile Activation",
            content: <ProfileActivation id={id} userStatus={status} />,
        },
        {
            id: `reset-password-${id}`,
            name: "Reset Password",
            content: <ResetPassword id={id} />,
        },
        {
            id: `permission-${id}`,
            name: "Permission",
            content: (
                <PermissionManager
                    id={id}
                    appPermissions={adminPermissions}
                    countryPermissions={country}
                />
            ),
        },
    ];

    if (adminType === "user-manager") {
        tabItems.pop();
    }

    return (
        <Tabs tabItems={getAuthorizedTabs(currentUserType, adminType) ? tabItems : basicTabItems} />
    );
};

export default SubComponent;
